import type { NextPage } from 'next';
import styles from './item-secondary.module.scss';
import Link from 'next/link';
import { ItemSecondaryType } from '@/types/header.types';

const ItemSecondary: NextPage<ItemSecondaryType> = ({
  className = '',
  chevron = 'Off',
  state = 'Default',
  about,
  onClick,
  href = '/',
}) => {
  return (
    <Link
      href={href}
      onClick={onClick}
      className={[styles.itemSecondary, className].join(' ')}
      data-chevron={chevron}
      data-state={state}
    >
      <div className={styles.about}>{about}</div>
    </Link>
  );
};

export default ItemSecondary;
